import {
  BookingListResponseDto,
  BookingsSummaryResponseDto,
  BookingStatistics,
} from '@planning/app/api'
import bookingsService from '@planning/services/bookingsService'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'

type BookingStatisticsWithTotal = BookingStatistics & {
  total: number
}

export type BookingsSummary = {
  expected: BookingStatisticsWithTotal
  onTerminal: BookingStatisticsWithTotal
}

export class VesselBookingsViewStore {
  data: BookingListResponseDto[] = []
  total = 0
  summaryData: BookingsSummaryResponseDto = {
    expected: {
      twentyFeet: 0,
      fortyFeet: 0,
      fortyFiveFeet: 0,
    },
    onTerminal: {
      twentyFeet: 0,
      fortyFeet: 0,
      fortyFiveFeet: 0,
    },
  }

  constructor() {
    makeObservable(this, {
      data: observable,
      total: observable,
      summaryData: observable,
      fetchSummary: action,
      fetch: action,
      summary: computed,
    })
  }

  async fetchSummary() {
    try {
      const res = await bookingsService.getVesselBookingSummary()
      runInAction(() => {
        this.summaryData = res
      })
    } catch (error) {
      console.error('Failed to fetch data:', error)
    }
  }

  async fetch(pageIndex: number, pageSize: number) {
    try {
      const res = await bookingsService.getVesselBookings(pageIndex + 1, pageSize)
      runInAction(() => {
        this.data = res.payload
        this.total = res.totalCount
      })
    } catch (error) {
      console.error('Failed to fetch data:', error)
    }
  }

  get summary(): BookingsSummary {
    return {
      expected: {
        ...this.summaryData.expected,
        total:
          this.summaryData.expected.twentyFeet +
          this.summaryData.expected.fortyFeet +
          this.summaryData.expected.fortyFiveFeet,
      },
      onTerminal: {
        ...this.summaryData.onTerminal,
        total:
          this.summaryData.onTerminal.twentyFeet +
          this.summaryData.onTerminal.fortyFeet +
          this.summaryData.onTerminal.fortyFiveFeet,
      },
    }
  }
}
